<template>
    <div>
        <v-progress-circular v-if="selectedSite && siteDetailsLoading" :size="50" :width="3" :color="ada.pink"
                             indeterminate
        ></v-progress-circular>
        <div v-else-if="selectedSite && siteDetails" class="mx-2">
            <slot></slot>
        </div>
        <div v-else :style="{height:'400px'}" class="noSiteSelected">
            Bitte eine Seite zum Bearbeiten auswählen.
        </div>
    </div>
</template>

<script>

import ada from "../../../scss/ada_colors.scss";

export default {
    name: "TabWrapper",
    components: {},
    data: () => {
        return {
            ada
        }
    },
    computed: {
        selectedSite() {
            return this.$store.state.emergency.selectedSite;
        },
        siteDetails() {
            return this.$store.state.emergency.siteDetails;
        },
        siteDetailsLoading() {
            return this.$store.state.emergency.siteDetailsLoading;
        },
        readOnly() {
            return this.$store.state.readOnly === 1;
        },
        activeTab() {
            return this.$store.state.emergency.activeTab;
        }
    },
    watch: {
        activeTab() {
            this.$emit('change', this.activeTab);
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .layout.row {
    margin: 0 !important;
}

::v-deep .description {
    margin: 10px 0;
    font-size: 1.1em;
}

</style>